import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { User, UserRecommendation } from '../../../interfaces/user';
import { RecommendationService } from '../../../services/recommendation.service';
import { Client } from '../../../generated-api-proxy';
import { ResultViewModel } from '../../../models/result-view-model';

@Component({
  selector: 'app-recommendation-tile',
  templateUrl: './recommendation-tile.component.html',
  styleUrls: ['./recommendation-tile.component.scss']
})
export class RecommendationTileComponent implements OnInit {

  @Input() result?: ResultViewModel;
  /** Shown inside the result card (see IBrand.resultLayout), so without its own heading */
  @Input() inline: boolean = false;

  public topRecommendation: UserRecommendation = { recommendationKey: "", viewed: "" };

  public image: string = "";

  constructor(public recommendationService: RecommendationService, private client: Client) {
  }

  ngOnInit(): void {
    if (this.result?.recommendationKeys && this.result?.recommendationKeys.length > 0) {
      let topRecommendationKey = this.result?.recommendationKeys[0];
      this.topRecommendation = {
        recommendationKey: topRecommendationKey,
        recommendation: undefined,
        viewed: ""
      };
      this.recommendationService.getRecommendation(topRecommendationKey).subscribe((recommendation) => {
        if (this.topRecommendation) {
          this.topRecommendation.recommendation = recommendation;
          this.image = recommendation.img_url;
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName !== "result" || !changes[propName].currentValue)
        return;

      if (this.result?.recommendationKeys && this.result?.recommendationKeys.length > 0) {
        let topRecommendationKey = this.result?.recommendationKeys[0];
        this.recommendationService.getRecommendation(topRecommendationKey).subscribe((recommendation) => {
          if (this.topRecommendation) {
            this.topRecommendation.recommendation = recommendation;
            this.image = recommendation.img_url;
          }
        });
      }
    }
  }
}
